// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.item-list-stack {
    display: grid;
    gap: 40px;
    margin-top: 34px;
    padding-bottom: 50px;
}

.stock-item-control-edit {
  background: white;
  text-align: right;
}`, "",{"version":3,"sources":["webpack://./src/web/component/StockingDeicingCard/styles.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB","sourcesContent":[".item-list-stack {\r\n    display: grid;\r\n    gap: 40px;\r\n    margin-top: 34px;\r\n    padding-bottom: 50px;\r\n}\r\n\r\n.stock-item-control-edit {\r\n  background: white;\r\n  text-align: right;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
